import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "table__header__content" }

import { computed, StyleValue } from 'vue';

/**
 * Props
 */
type Props = {
  forceRight?: boolean;
  forceCenter?: boolean;
  hasRightBorder?: boolean;
  useResizer?: boolean;
  sticky?: boolean | 'left' | 'right';
  stickyOffset?: number;
  contentPadding?: number;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'EzHeader',
  props: {
    forceRight: { type: Boolean, default: false },
    forceCenter: { type: Boolean, default: false },
    hasRightBorder: { type: Boolean, default: false },
    useResizer: { type: Boolean, default: false },
    sticky: { type: [Boolean, String], default: false },
    stickyOffset: { default: 0 },
    contentPadding: { default: 16 }
  },
  emits: ["resizer"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "ea262c08": (`0 ${props.contentPadding}px`)
}))

const props = __props;

const emits = __emit;
const stickyStyle = computed((): StyleValue => {
  if (props.sticky === 'right') {
    return {
      position: 'sticky',
      right: `${props.stickyOffset}px`,
      zIndex: '1',
    };
  } else if (props.sticky) {
    return {
      position: 'sticky',
      left: `${props.stickyOffset}px`,
      zIndex: '1',
    };
  } else {
    return null;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["table__header", {
      'table__header--right': props.forceRight,
      'table__header--center': props.forceCenter,
      'table__header--border--right': props.hasRightBorder,
    }]),
    style: _normalizeStyle(stickyStyle.value)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (_ctx.useResizer)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "table__header__resizer",
          onMousedown: _cache[0] || (_cache[0] = (e) => {emits('resizer', e)})
        }, null, 32))
      : _createCommentVNode("", true)
  ], 6))
}
}

})